export const staffConversationKeys = {
  all: ['conversation', 'staff'] as const,
  list: (placeId = '') => [...staffConversationKeys.all, 'list', placeId] as const,
};
